import util from '../../../util';

const loadLastCodeServices = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()

    payload.context.axios.get('api/services/lastCode', {headers}).then((response) => {
      const code = response.data[0].code;

      resolve(code)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el código de servicio.')
        reject(error.response)
      }
      reject()

    });

  })
}
const loadServicesList = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get('api/services', {headers}).then((response) => {
      commit('setServiceList', response.data)
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar la lista de servicios.')
        reject(error.response)
      }
      reject()
    });
  })
}

const findServiceById = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`api/services/${payload.id}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el servicio.')
        reject(error.response)
      }
      reject()
    });
  })
}

const saveServices = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`api/services`,payload.services ,{headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el servicio.')
        reject(error.response)
      }
      reject()
    });
  })
}

const updateServices = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.put(`api/services`,payload.services ,{headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el servicio.')
        reject(error.response)
      }
      reject()
    });
  })
}

const deleteService = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.delete(`api/services/${payload.id}`,{headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      }
      reject()
    });
  })
}

export default {
  loadLastCodeServices,
  saveServices,
  loadServicesList,
  findServiceById,
  updateServices,
  deleteService
}



// WEBPACK FOOTER //
// ./src/store/modules/services/actions.js